(() => {
  angular
    .module('gm.common.2fa')
    .controller('twoFAModalController', twoFAModalController);

  function twoFAModalController(
    close,
    requestSMS,
    type,
    $scope,
    $timeout
  ) {
    'ngInject';

    const vm = this;
    vm.cancel = cancel;
    vm.close = close;
    vm.requestSMS = requestSMS;

    $scope.twoFAModal = {
      open: false,
      type: ''
    };
    let value;

    activate();

    function activate() {
      $scope.digits = [{ value }, { value }, { value }, { value }, { value }, { value }, { value }];
      vm.type = type;
      $timeout(() => selectDigit(0), 600);
    }

    $scope.onChange = (index) => {
      const string = $scope.digits[index].value.toString();
      string.split('').forEach((digit, i) => {
        if (index + i <= 6) {
          $scope.digits[index + i].value = digit;
          $scope.digits[index + i].readonly = true;
        }
      });
      if (index + string.length <= 6) {
        selectDigit(index + string.length);
      } else {
        const code = $scope.digits.map(digit => digit.value).join('');
        close(code);
      }
    };

    $scope.onKeyup = ($event, index) => {
      if ($event.which === 8 && index !== 0) { // backspace
        $scope.digits[index - 1].value = undefined;
        $scope.digits[index - 1].readonly = false;
        selectDigit(index - 1);
      }
    };

    function cancel() {
      return close('-');
    }

    function selectDigit(index) {
      const element = angular.element(`#digit${index}`);
      element.on('touchstart', () => {
        element.focus();
        element.off('touchstart');
      });
      element.trigger('touchstart');
    }
  }
})();
